import React from 'react'
import { BrowserRouter as Router, Link } from 'react-router-dom'
import { Segment, Container, Icon } from 'semantic-ui-react'
import { isMobile } from 'react-device-detect'

import logo from '../assets/osi.png'
import DesktopView from './desktopView'
import MobileView from './mobileView'
import '../css/App.css'

function App () {
  return (
    <div className='App'>
      <Router>
        <Segment
          className='app-header'
          attached
          textAlign={isMobile && 'center'}
        >
          <Container>
            <Link to='/' style={{ color: 'inherit' }}>
              <img
                src='https://avatars2.githubusercontent.com/u/1070632'
                alt='img-logo'
                width='40'
                className='app-header-logo'
              />
              <Icon name='add' className='add-icon' />
              <img
                src={logo}
                alt='osi-logo'
                width='32'
                className='app-header-logo'
              />
            </Link>
          </Container>
        </Segment>
        {!isMobile ? <DesktopView /> : <MobileView />}
      </Router>
    </div>
  )
}

export default App
